import { CloseButton, TextInput } from "@mantine/core";

import MultiSearchInputWrapper from "@/components/MultiSearchInputWrapper";

import {
  CLEAR_SEARCH_LABEL,
  SEARCH_BAR_WIDTH,
  SEARCH_LABEL,
  SEARCH_OPTIONS,
  SEARCH_PLACEHOLDERS,
} from "./constants/open-statements";
import { OpenStatementsSearchOption } from "./types/open-statements";

interface OpenStatementsSearchProps {
  query: string;
  onQueryChange: (query: string) => void;
  searchOption: OpenStatementsSearchOption;
  onSearchOptionChange: (option: OpenStatementsSearchOption) => void;
}

export default function OpenStatementsSearch({
  query,
  onQueryChange,
  searchOption,
  onSearchOptionChange,
}: OpenStatementsSearchProps) {
  return (
    <MultiSearchInputWrapper
      wrap="nowrap"
      label={SEARCH_LABEL}
      selected={searchOption}
      options={SEARCH_OPTIONS}
      w={{ base: "100%", sm: SEARCH_BAR_WIDTH }}
      menuTargetTestId="open-statements-search-option"
      onChangeOption={(option) => onSearchOptionChange(option as OpenStatementsSearchOption)}
    >
      <TextInput
        w="100%"
        value={query}
        data-testid="open-statements-search"
        placeholder={SEARCH_PLACEHOLDERS[searchOption]}
        onChange={(event) => onQueryChange(event.currentTarget.value)}
        rightSection={
          query ? (
            <CloseButton
              size="sm"
              aria-label={CLEAR_SEARCH_LABEL}
              onClick={() => onQueryChange("")}
              data-testid="open-statements-search-clear"
            />
          ) : null
        }
      />
    </MultiSearchInputWrapper>
  );
}
